(() => {

  const init = (popup) => {
  const sectionId = popup.id.replace('uw-printer-popup-', '');


  const initCollectionTop = () => {

    const popup = document.getElementById(
      `uw-printer-popup-${sectionId}`
    );


    if (!popup || popup.dataset.initialized === 'true') {
      return;
    }


    popup.dataset.initialized = 'true';


    /*
     * Popup direct onder body plaatsen.
     *
     * Hiermee voorkomen we problemen met:
     * - sticky headers
     * - z-index
     * - overflow hidden
     * - stacking contexts
     */
    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }


    let lastFocusedElement = null;



    /*
     * Focusable elementen binnen popup ophalen
     */
    const getFocusableElements = () => {

      return Array.from(
        popup.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => {
        return element.getClientRects().length && !element.closest('[hidden]');
      });

    };



    /*
     * Popup openen
     */
    const openPopup = (trigger) => {

      lastFocusedElement = trigger;

      popup.hidden = false;

      document.body.classList.add('uw-popup-open');


      const closeButton = popup.querySelector(
        '.uw-printer-popup__close'
      );


      if (closeButton) {
        closeButton.focus();
      }

    };



    /*
     * Popup sluiten
     */
    const closePopup = () => {

      popup.hidden = true;

      document.body.classList.remove('uw-popup-open');


      if (lastFocusedElement) {
        lastFocusedElement.focus();
      }

    };



    /*
     * Open buttons
     */
    document
      .querySelectorAll(
        `[data-printer-popup-open][aria-controls="uw-printer-popup-${sectionId}"]`
      )
      .forEach((button) => {

        button.addEventListener('click', () => {
          openPopup(button);
        });

      });



    /*
     * Close buttons + backdrop
     */
    popup
      .querySelectorAll('[data-printer-popup-close]')
      .forEach((element) => {

        element.addEventListener('click', () => {
          closePopup();
        });

      });



    /*
     * Keyboard bediening
     */
    popup.addEventListener('keydown', (event) => {


      /*
       * Escape
       */
      if (event.key === 'Escape') {

        closePopup();

        return;

      }


      /*
       * Focus trap
       */
      if (event.key !== 'Tab') {
        return;
      }


      const focusable = getFocusableElements();


      if (!focusable.length) {
        return;
      }


      const firstElement = focusable[0];

      const lastElement =
        focusable[focusable.length - 1];


      /*
       * Shift + Tab vanaf eerste element
       */
      if (
        event.shiftKey &&
        document.activeElement === firstElement
      ) {

        event.preventDefault();

        lastElement.focus();

      }


      /*
       * Tab vanaf laatste element
       */
      if (
        !event.shiftKey &&
        document.activeElement === lastElement
      ) {

        event.preventDefault();

        firstElement.focus();

      }

    });

  };



  initCollectionTop();
  };
  const scan = (root = document) => root.querySelectorAll('[id^="uw-printer-popup-"]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
